module.exports = __webpack_public_path__ + "img/cone.bb3cbb47.svg";